module.exports = __webpack_public_path__ + "static/media/bunkey-avatar-17.ff3a8f60.png";